interface IRoutePaths {
  checkEmailMessage: string;
  checkEmailPasswordRecover: string;
  fullSignUp: string;
  landing: string;
  manageDetails: string;
  passwordRecover: string;
  passwordRecoveryConfirmation: string;
  passwordResetForm: string;
  quote: string;
  quoteAuctionHouseInfo: string;
  quoteDetails: string;
  quotePaymentSuccess: string;
  quoteRequestedConfirmation: string;
  quoteShippingInfo: string;
  quoteSummary: string;
  quoteUserInfo: string;
  user: string;
  userDashboard: string;
  userDocumentDetail: string;
  userLogin: string;
  userQuotes: string;
  userSettings: string;
  userSignUpConfirmation: string;
  usershipments: string;
}

export const ROUTE_PATHS: IRoutePaths = {
  checkEmailMessage: 'check-email',
  checkEmailPasswordRecover: 'reset-your-password',
  fullSignUp: 'sign-up',
  landing: '/',
  manageDetails: 'manage-your-documents',
  passwordRecover: 'password-recover',
  passwordResetForm: '/login/password-reset',
  passwordRecoveryConfirmation: 'password-reset-confirmation',
  quote: 'quote',
  quoteUserInfo: 'user',
  quoteAuctionHouseInfo: 'auction-house',
  quoteShippingInfo: 'shipping',
  quoteSummary: 'summary',
  quotePaymentSuccess: 'payment/success',
  quoteRequestedConfirmation: 'requested',
  quoteDetails: 'details/:id',
  user: 'user',
  userLogin: '/login',
  userDashboard: 'my-account',
  userDocumentDetail: 'document-detail/:id',
  userQuotes: 'quotes',
  userSettings: 'settings',
  userSignUpConfirmation: '/login/registration-confirm',
  usershipments: 'shipments',
};
